import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { UseAuth } from "../../context/AuthContext";
import Sidebar from "../../components/common/UI/Sidebar";
import { UseSetting } from "../../context/SettingContext";
import PageLoader from "../../components/common/UI/PageLoader";

const GuestLayout = () => {
  const navigate = useNavigate();
  const { loading } = UseSetting();
  const {
    authUser: { token, authScope, user: { clientCode } },
  } = UseAuth();

  useEffect(() => {
    sessionStorage.removeItem("caseNumber");
  }, [])

  useEffect(() => {
    if (token && authScope) {
      if (authScope === "Evite") {
        navigate(`/${clientCode}/choose-country`);
      }
    }
  }, [token, clientCode, authScope, navigate]);
  let isAutoLogin = window.location.href.includes("autologin")
  return (
    <>
      {!loading ? (
        isAutoLogin ? <Outlet /> : <div className="HomeContainer">
          <Sidebar />
          <div className="BannerContent">
            <Outlet />
          </div>
        </div>
      ) : (
        <PageLoader />
      )}
    </>
  );
};

export default GuestLayout;
